'use client';
import Cookies from 'js-cookie';
import { useEffect } from 'react';

import { Role } from '@/db/schema';

import { clearRedirectCookie } from '../user-actions';
import { REDIRECT_AFTER_LOGIN_KEY } from './set-redirect-cookie-effect';

export function HandleRedirectCookieEffect({ roles }: { roles: Role[] }) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirect =
      params.get('redirect') ||
      localStorage.getItem(REDIRECT_AFTER_LOGIN_KEY) ||
      Cookies.get('redirect');

    if (redirect) {
      localStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
      clearRedirectCookie().then(() => {
        location.href = redirect;
      });
    } else if (roles.includes(Role.Admin)) {
      location.href = '/admin/dashboard';
    } else if (roles.includes(Role.Provider)) {
      location.href = '/provider/dashboard';
    } else if (roles.includes(Role.Affiliate)) {
      location.href = '/affiliate/dashboard';
    } else {
      location.href = '/user/dashboard';
    }
  }, [roles]);

  return null;
}
